import { errorBaseStyles } from '../commonBasedStyles';
export var Form = {
  baseStyle: {
    requiredIndicator: {
      display: 'inline-block',
      color: errorBaseStyles.requiredIndicatorColor,
      pl: '.5625rem',
      '> span': {
        display: 'inline-block'
      }
    },
    requiredText: {
      ml: '.357rem'
    },
    helperText: {
      lineHeight: '1.25rem',
      mb: '1rem',
      _groupDisabled: {
        color: 'grey.800'
      }
    }
  }
};